module.exports = __webpack_public_path__ + "img/加盟流程.c490c1ef.png";